import { defineTranslateKeys } from 'lib/tolgee'

export default defineTranslateKeys({
  typeHere: {
    defaultValue: 'Digite aqui...',
    key: 'text-editor-typeHere',
  },
  errorLoading: {
    defaultValue: 'Erro ao carregar o editor',
    key: 'text-editor-errorLoading',
  },
})
